import { useEffect, useState } from "react";
import { Download, Loader2, ShieldAlert } from "lucide-react";
import { staffApi, errMsg, saveBlob } from "./api";
import { Status } from "./Shell";

const ListCard = ({ item }) => {
  const [status, setStatus] = useState({});
  const download = async () => {
    setStatus({ state: "loading" });
    try {
      const res = await staffApi.get(`/export/${item.key}`, { responseType: "blob" });
      saveBlob(res.data, `${item.key}-${new Date().toISOString().slice(0, 10)}.csv`);
      setStatus({ state: "success", msg: "Downloaded. Opens in Excel, Numbers or Google Sheets." });
    } catch (err) {
      setStatus({ state: "error", msg: await errMsg(err, "Download failed. Please try again.") });
    }
  };
  return (
    <li className="flex flex-col justify-between gap-4 border border-mist bg-white p-5" data-testid={`staff-list-card-${item.key}`}>
      <div>
        <p className="font-semibold text-navy">{item.title}</p>
        <p className="mt-1 text-sm text-slate" data-testid={`staff-list-count-${item.key}`}>{item.count} record{item.count === 1 ? "" : "s"}</p>
        {item.restricted && (
          <p className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-gold-deep">
            <ShieldAlert size={14} aria-hidden="true" /> Restricted: authorized personnel only
          </p>
        )}
      </div>
      <Status status={status} testId={`staff-list-status-${item.key}`} />
      <button type="button" onClick={download} disabled={status.state === "loading"} className="btn btn-navy disabled:opacity-60" data-testid={`staff-list-download-${item.key}`}>
        {status.state === "loading" ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />} Download Spreadsheet
      </button>
    </li>
  );
};

export const DownloadsPanel = () => {
  const [lists, setLists] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    staffApi.get("/lists")
      .then((r) => setLists(Array.isArray(r.data) ? r.data : []))
      .catch(async (e) => setError(await errMsg(e)));
  }, []);
  if (error) return <p className="text-sm text-fire" role="alert">{error}</p>;
  if (!lists) return <Loader2 className="animate-spin text-navy" />;
  if (!lists.length) return <p className="text-sm text-slate" data-testid="staff-lists-empty">Your account doesn't have access to any lists yet. Ask the Administrator.</p>;
  return (
    <div data-testid="staff-downloads-panel">
      <p className="mb-6 text-sm text-slate">Every download is recorded with your name, the date and time, and the list. Store downloaded files securely and delete them when you're done.</p>
      <ul className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{lists.map((l) => <ListCard key={l.key} item={l} />)}</ul>
    </div>
  );
};
